import httpUtils from '../utils/http-utils';

const SERVICE_NAME = process.env.REACT_APP_API_ENDPOINT+"/banner";

const add = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/add", payload);
}

const edit = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/edit", payload);
}

const remove = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/delete", payload);
}

const search = (condition = {}, paginable = { rowPerPage: 999, currentPage: 1 }) => {
    return httpUtils.post(SERVICE_NAME + "/search", {condition, paginable});
}

const saveDisplay = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/saveDisplay", payload);
}

const getDisplay = () => {
    return httpUtils.post(SERVICE_NAME + "/getDisplay");
}

const bannerApi = {
    add,
    edit,
    remove,
    search,
    saveDisplay,
    getDisplay
}

export default bannerApi;